// extracted by mini-css-extract-plugin
export default {"root":"unperformed_root__6IVfT","placeHolderShimmer":"unperformed_placeHolderShimmer__ntx56"};